import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { calibrateCameraFailed, calibrateCameraSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* calibrateCamera(action) {
  try {
    const { id, data } = action.payload;
    const url = `${BACKEND_URL}/api/v1/camera/${id}/calibrate`;
    const dataResponse = yield makeRequest(url, data, action, 'POST', true);
    if (dataResponse.status === CREATED) {
      yield put(calibrateCameraSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(calibrateCameraFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(calibrateCameraFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
